import { rest } from 'msw';

export const handlers = [
  rest.get(`http://localhost:8080/section/mix-of-business`, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        sectionKey: 'mix-of-business',
        sectionTitle: 'Mix of Business',
        sectionReportViews: ['PU', 'CR', 'LQ', 'RP', 'ST', 'RV', 'OP', 'LG'],
        subSectionResults: [
          {
            subSectionKey: 'mix-of-business',
            reportViewList: ['OP', 'PU', 'FS'],
            subSectionType: 'OR_BY_LOB',
            operatingRatiosByLOBRows: [
              {
                label: 'Medicare Supplement',
                rowKey: '1234',
                rowType: 'AMOUNT',
                rowClass: 'TOTAL',
                benchmark:
                  'CY: Loss Ratio >85% OR Exp Ratio >15% OR Combined Ratio >105% OR UW G(L) <0',
                rowDisplay: {
                  cr: 'HIDE',
                  lg: 'HIDE',
                  lq: 'HIDE',
                  mk: 'HIDE',
                  op: 'HIDE',
                  pu: 'HIDE',
                  rp: 'HIDE',
                  rv: 'HIDE',
                  st: 'HIDE',
                  fs: 'HIDE'
                },
                medicalLossRatioCurrentYear: {
                  value: 195.974
                },
                medicalLossRatioPriorYear: {
                  value: 452.84
                },
                adminExpsenseRatioCurrentYear: {
                  value: 245.731
                },
                adminExpsenseRatioPriorYear: {
                  value: 286.274
                },
                combinedRatioCurrentYear: {
                  value: 133.025
                },
                combinedRatioPriorYear: {
                  value: 90.392
                },
                underWritingGLCurrentYear: {
                  value: -1345.95
                },
                underWritingGLPriorYear: {
                  value: -21251.77
                }
              }
            ]
          }
        ]
      })
    );
  })
];
